import { apiConfig } from 'store/api/tournamentService';

const COMMON_CONFIG = {
  game_code: 'uncrossable_rush',
  player_currency: 'EUR',
  included_types: ['TOURNAMENT'],
  included_statuses: ['RUNNING', 'COMING_SOON', 'ENDED'],
  lang: 'EN',
  locale: 'en-US',
  game_url: `${apiConfig[process.env.REACT_APP_VERSION]}tournament-service/client-area/v1/b2b-tournament/launch-game`,
};

export const CONFIG = {
  local: {
    ...COMMON_CONFIG,
    operator_code: 'gt_1124',
  },
  stage: {
    ...COMMON_CONFIG,
    operator_code: 'gt_1124',
  },
  prod: {
    ...COMMON_CONFIG,
    operator_code: 'eu_10077',
  },
};

export const generateUserId = (userId, eventId) => `${userId}:${eventId}`;
